export default __webpack_public_path__ + "static/media/Chestguard of the Triumphant.63bc90f9.jpg";